export const FINANCIAL_SUB_TABS_ADMIN = [
  { value: "transactions", pathname: "transaction" },
  { value: "financialGroup", pathname: "financial-group",},
  { value: "withdrawals", pathname: "withdrawal" },
  { value: "debts", pathname: "debts" },
  { value: "payToDriver", pathname: "pay-to-driver" },
  { value: "parentTransaction", pathname: "parent-transaction" },
  { value: "driverTransaction", pathname: "driver-transaction" },
  { value: "approveParentTransaction", pathname: "approve-parent-transaction" },
  { value: "onlineTransaction", pathname: "online-transaction" },
];
export const LOCATION_SUB_TABS_ADMIN = [
  { value: 'province'    , pathname: 'province'     },
  { value: 'city'        , pathname: 'city'         },
  { value: 'area'        , pathname: 'area'         },
  { value: 'neighborhood', pathname: 'neighborhood' },
]
export const LOCATION_SUB_TABS_COMPANY = [
  { value: 'area'        , pathname: 'area'         },
  { value: 'neighborhood', pathname: 'neighborhood' },
]
export const FINANCIAL_SUB_TABS = [
  { value: "transactions", pathname: "transaction" },
  { value: "withdrawals", pathname: "withdrawal" },
];
export const ADMIN_FINANCIAL_TABS = [
  { value: 'paymetOnline2Company', pathname: 'paymeht-online-2-company' },
]
export const APPROVE_PARENT_TRANSACTION = [
  { value: "waitForApprove", pathname: "pending" },
  { value: "rejectedTransaction", pathname: "rejected" },
];
export const ONLINE_TRANSACTION = [
  { value: "driver", pathname: "driver" },
  { value: "parent", pathname: "parent" },
];
export const WITHDRAWAL_TYPES = [
  { value: 'admin'  , pathname: 'admin'   },
  { value: 'company', pathname: 'company' },
  { value: 'driver' , pathname: 'driver'  },
];
export const FINANCIAL_SUB_TABS_COMPANY = [
  { value: "transactions", pathname: "transaction" },
  { value: "withdrawals", pathname: "withdrawal" },
  { value: "debtsToDriver", pathname: "debt-to-driver" },
  { value: "factors", pathname: "company-factor" },
  { value: "factorsCompany", pathname: "factor-company" },
  { value: "financialReportCompany", pathname: "financial-report-company" },
];
export const OTHER_SUB_TABS = [{ value: "addCity", pathname: "add-city" }];
export const SUPERAGENT_TABS_FOR_ADMIN = [
  {
    name: "provinceEducation",
    value: "provinceEducation",
    pathname: "education-province",
  },
  { name: "cityEducation", value: "cityEducation", pathname: "education-city" },
];
export const SUPERAGENT_TABS = [
  { value: "cityEducation", pathname: "education-city" },
];
export const COMPANY_OTHER_TABS = [
  { value: "uploadDocs", pathname: "upload-document" },
];
export const DRIVER_TABS = [
  { value: "senjedDrivers", pathname: "senjedDrivers" },
  { value: "unknownDrivers", pathname: "unknownDrivers" },
];

export const FILTER_USER_BY_FAVORIT_CITIES = [
  { _id: undefined                 , pathname: ''                        , value: 'all'      },
  { _id: '6506c050b65b286093cdd05b', pathname: '6506c050b65b286093cdd05b', value: 'ramsar'   },
  { _id: '6506c050b65b286093cdd052', pathname: '6506c050b65b286093cdd052', value: 'tonekabon'},
  { _id: '685f73f9207351f1103c5e1e', pathname: '685f73f9207351f1103c5e1e', value: 'chaboksar'},
  { _id: '685f7340207351f1103c5e1d', pathname: '685f7340207351f1103c5e1d', value: 'kelachiy' },
  { _id: '6506c050b65b286093cdd00d', pathname: '6506c050b65b286093cdd00d', value: 'rodsar'   },
];
